var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 34,
    viewBox: "0 0 298 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.664246 15.0969C-0.221405 15.9825 -0.221405 17.4185 0.664246 18.3041L15.0969 32.7368C15.9825 33.6224 17.4185 33.6224 18.3041 32.7368C19.1898 31.8511 19.1898 30.4152 18.3041 29.5295L5.47513 16.7005L18.3041 3.87149C19.1898 2.98583 19.1898 1.5499 18.3041 0.664238C17.4185 -0.22142 15.9825 -0.22142 15.0969 0.664238L0.664246 15.0969ZM297.595 16.7005V14.4326L2.26788 14.4326V16.7005V18.9684L297.595 18.9684V16.7005Z",
    fill: "#1E3240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.8f7e95e07e934aab79f1b7f320de0695.svg";
export { ForwardRef as ReactComponent };